import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ColumnComponent } from '../column.component';
import { type SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';
import { ColumnListLayoutModifierClass } from 'src/app/models/enum/shared/column-list-layout-types';

@Component({
  selector: 'app-column-craft-designation',
  imports: [AsyncPipe, SharedModule],
  templateUrl: './column-craft-designation.component.html',
  styleUrl: './column-craft-designation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnCraftDesignationComponent extends ColumnComponent {
  constructor() {
    super();
  }

  @Input() useNgContent: boolean;
  @Input() displayFormat: SectionColumnConfigDataValue;
  @Input() columnListLayoutModifierClass: ColumnListLayoutModifierClass = null;
}
